<!-- 视频监控 -->
<template>
  <div class="monitor">
    <div class="content">
      <el-container class="videosur_content">
        <el-aside class="video_aside">
          <el-row
            class="row-bg videosur_menu"
            :class="{'menu_active':index==choosed}"
            v-for="(item, index) in allVideoData"
            :key="index"
          >
            <div class="menu_list" @click="checkItem(item, index)">{{ item.name }}</div>
          </el-row>
        </el-aside>
        <el-container>
          <el-main>
            <div class="video_window">
              <video
                :id="'video'+videoId"
                class="video-js vjs-default-skin"
                controls
                muted
                preload="auto"
                poster="@/assets/logo.png"
                autoplay
              >
                <source  type="application/x-mpegURL" />
              </video>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import monitorTypes from '@/store/types/monitor'
import 'video.js/dist/video-js.css'
import videojs from 'video.js'
import 'videojs-contrib-hls'
import axios from 'axios'
import config from '@/config'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
  },
  data () {
    // 这里存放数据
    return {
      choosed: 0,
      allVideoData: [],
      name: '',
      videoId: '',
      videoObj: {},
      token: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    newGuid () {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) {
          guid += '-'
        }
      }
      return guid
    },
    // 获取视频数据并筛选
    getAllVideoSurData () {
      this.$store.dispatch(monitorTypes.GET_MONITOR_STATIONS).then(data => {
        this.allVideoData = data.results
        this.choosed = 0
        this.name = this.allVideoData[0].name
        this.getVideo()
        this.getVideoUrl()
      })
    },
    getVideoUrl () {
      this.$store
        .dispatch(monitorTypes.GET_VIDEOMONITOR_URL, {
          name: this.name
        })
        .then(data => {
          this.videoObj.src({
            src: 'data.url',
            type: 'application/x-mpegURL'
          })
        })
    },

    getVideoUrlbyId (vId) {
      axios.get(config.ApiRootVideo + '/api/urlsFromISC?cameraIndexCode=' + vId, { headers: { 'Authorization': this.token } }).then(res => {
        if (res.data.code === '200') {
          let videoUrl = res.data.result
          this.videoObj.src({
            src: videoUrl,
            type: 'application/x-mpegURL'
          })
        }
      })
    },
    getVideo () {
      axios.get(config.ApiRootVideo + '/auth/getAccessToken?appId=EmzZikmK').then(res => {
        if (res.data.code === '200') {
          this.token = res.data.result
          axios.get(config.ApiRootVideo + '/api/videoListFromDB?pageNumber=1&pageSize=20', { headers: { 'Authorization': this.token } }).then(res => {
            if (res.data.code === '200') {
              let result = res.data.result.content
              result.forEach(element => {
                this.allVideoData.push({
                  'id': element.videoId,
                  'name': element.videoName,
                  'type': 2
                })
              })
            }
          })
        }
      })
    },
    checkItem (item, index) {
      this.choosed = index
      this.name = item.name
      if (item.type && item.type === 2) {
        this.getVideoUrlbyId(item.id)
      } else {
        this.getVideoUrl()
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.videoId = this.newGuid()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    let videlId = 'video' + this.videoId
    this.videoObj = videojs(
      videlId,
      {
        bigPlayButton: false,
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true,
        autoplay: true
      },
      function () {
        this.play()
      }
    )
    this.getAllVideoSurData()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.monitor {
  .videosur_content {
    width: 100%;
    padding-left: 1%;
    height: 100%;
    background-color: #fff;
    border-radius: 5px;
    .video_window > div {
      width: 1438px;
      height: 772px;
    }
    .video_aside {
      width: 380px !important;
      background-color: rgb(238, 241, 246);
      margin: 20px 0;
      border-radius: 5px;
    }
    .videosur_menu {
      width: 100%;
      height: 60px;
      padding: 5px;
      cursor: pointer;
      &:hover {
        background: #7e99bd;
      }
      .menu_list {
        width: 100%;
        height: 40px;
        text-align: left;
        line-height: 40px;
        padding: 5px 10%;
        font-size: 16px;
      }
    }
    .menu_active {
      background: #7e99bd;
      color: #fff;
    }
  }
}
</style>
